import React, { Component } from "react";
import "./Education.css";
import grid1 from '../../features/Icons/Grid.svg';
import grid2 from '../../features/Icons/Grid2.svg';
import grid3 from '../../features/Icons/Grid3.svg';
import grid4 from '../../features/Icons/Grid4.svg';
import grid5 from '../../features/Icons/Grid5.svg';
import grid6 from '../../features/Icons/Grid6.svg';
import img1 from '../../images/pexels-cdc-library-3992949.jpg';
import img2 from '../../images/pexels-kampus-5940706.jpg';
import img3 from '../../images/pexels-vanessa-loring-7868822.jpg';
import img4 from '../../images/pexels-mkvisuals-2781195.jpg';
import educationImage from '../../images/IMG_4837.png';

class Education extends Component {
    render(){
        return(
            <>
                <div className="education-hero">
                    <img src={educationImage} alt="education" className="education-image"/>
                    <div className="education-overlay">
                        <h1>Making Education Accessible to All.</h1>
                        <p>Improving the Future LLC is an eduational entitiy that encompasses STEM Consulting, Special Eduation Services, Curriculum and Program design, Website design, and After school services including tutoring. 
                        </p>
                    </div>
                </div>
                <div className="info-content">
                    <h2>What We Do</h2>
                    <div class="grid-container">
                        <div class="grid-item">
                            <div class="icon-container">
                            <img src={grid1} alt="Icon 1" class="icon" />
                            </div>
                            <p>Curriculum and Program Design</p>
                        </div>
                        <div class="grid-item">
                            <div class="icon-container">
                            <img src={grid4} alt="Icon 2" class="icon" />
                            </div>
                            <p>Website and Application Design</p>
                        </div>
                        <div class="grid-item">
                            <div class="icon-container">
                            <img src={grid2} alt="Icon 3" class="icon" />
                            </div>
                            <p>Professional Learning and Public Speaking</p>
                        </div>
                        <div class="grid-item">
                            <div class="icon-container">
                            <img src={grid3} alt="Icon 4" class="icon" />
                            </div>
                            <p>STEM Education Consulting</p>
                        </div>
                        <div class="grid-item">
                            <div class="icon-container">
                            <img src={grid5} alt="Icon 5" class="icon" />
                            </div>
                            <p>After School Programming and Tutoring</p>
                        </div>
                        <div class="grid-item">
                            <div class="icon-container">
                            <img src={grid6} alt="Icon 6" class="icon" />
                            </div>
                            <p>Special Education Consulting</p>
                        </div>
                    </div>
                    <a href="/services" className="btn primary-btn">Learn More</a>
                </div>

                <section className="benefits-section">
                    <h2>Benefits of Working With Us</h2>
                    <div className="benefits-grid">
                        <div className="benefit-card" style={{ backgroundImage: `url(${img1})` }}>
                            <div className="benefit-content-overlay">
                                <h3>Experienced Educators</h3>
                                <p>Work with professional educators with 20+ years of experience across Pre-K to 12+.</p>
                            </div>
                        </div>

                        <div className="benefit-card" style={{ backgroundImage: `url(${img2})` }}>
                            <div className="benefit-content-overlay">
                                <h3>Personalized Care</h3>
                                <p>One-on-one attention ensures every client achieves their desired outcomes.</p>
                            </div>
                        </div>

                        <div className="benefit-card" style={{ backgroundImage: `url(${img3})` }}>
                            <div className="benefit-content-overlay">
                                <h3>Hands-On Approach</h3>
                                <p>Active, real-world experiences improve cognitive ability and raise career awareness.</p>
                            </div>
                        </div>

                        <div className="benefit-card" style={{ backgroundImage: `url(${img4})` }}>
                            <div className="benefit-content-overlay">
                                <h3>Content Knowledgeable</h3>
                                <p>Our team brings expertise in literacy, STEM, multicultural learning, and special education.</p>
                            </div>
                        </div>
                    </div>
                </section>
            
                <div className="inspire">
                    <div className="center-text">
                        <h1 className="font-text">
                            Let’s Work Together to Improve the Future One Child at a Time
                        </h1>
                        <a href="/contact" className="btn primary-btn">
                            Contact Us Today!
                        </a>
                    </div>
                </div>
        </>
        );
    }
}
export default Education;
